import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SuraCommonsUiModule } from '@surainvestments/sura-common-ui';
import { sharedComponents } from './components';
import { DialogMessageComponent } from './components/dialog-message/dialog-message.component';
import { PollButtonComponent } from './components/poll-button/poll-button.component';
import { PollComponent } from './components/poll/poll.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { TimeoutMessageComponent } from './components/timeout-message/timeout-message.component';
import { NoSpacesDirective } from './directives/noSpaces/noSpaces.directive';
import { RutDirective } from './directives/rut/rut.directive';
import { RutNameDirective } from './directives/rutName/rut-name.directive';
import { MaterialModule } from './modules/material.module';
import { CurrencyPipeCustom } from './pipes/currency.pipe';
import { DynamicPipe } from './pipes/dynamic.pipe';
import { HighlightTextPipe } from './pipes/highlight-text.pipe';
import { MonthNamePipe } from './pipes/month-name.pipe';
import { RutPipe } from './pipes/rut.pipe';
import { SafePipe } from './pipes/safe.pipe';

//mmb implementaciones
import { FormControlFileDirective } from '@shared/directives/form-control-file.directive';
import { ControlErrorPipe } from '@shared/pipes/control-error.pipe';
import { ModalFiltroInstrumentosComponent } from '../features/components/asesor/pershing/orden-compra/components/modal-filtro-instrumentos/modal-filtro-instrumentos.component';
import { VisualizadorClientesComponent } from '../features/components/visualizador-clientes/visualizador-clientes.component';
import { MmbButtonComponent } from './components/mmb-button/mmb-button.component';
import { MmbCheckboxComponent } from './components/mmb-checkbox/mmb-checkbox.component';
import { MmbDropdownAutocompleteComponent } from './components/mmb-dropdown-autocomplete/mmb-dropdown-autocomplete.component';
import { MmbDropdownComponent } from './components/mmb-dropdown/mmb-dropdown.component';
import { MmbInputMontoComponent } from './components/mmb-input-monto/mmb-input-monto.component';
import { MmbInputTextComponent } from './components/mmb-input-text/mmb-input-text.component';
import { MmbRadioButtonComponent } from './components/mmb-radio-button/mmb-radio-button.component';
import { MmbTituloPaginaComponent } from './components/mmb-titulo-pagina/mmb-titulo-pagina.component';
import { ModalFiltroResponsivoComponent } from './components/modal-filtro-responsivo/modal-filtro-responsivo.component';
import { DropFilesDirective } from './directives/drop-files.directive';
import { MaskCurrencyDirective } from './directives/mask-number/mask-currency.directive';
import { NumerosDirective } from './directives/numeros/numeros.directive';
import { VerPassInputDirective } from './directives/verPassInput/ver-pass-input.directive';
import { CantidadPipeCustom } from './pipes/cantidad.pipe';
import { ClpPipeCustom } from './pipes/clp.pipe';
import { FechahoraPipeCustom } from './pipes/fechahora.pipe';
import { FechahoraPipeFormato } from './pipes/fechahoraformato.pipe';
import { FormatoMontoConDecimalesPipe } from './pipes/formatoConDecimales.pipe';
import { PercentageOrBlankPipe } from './pipes/porcentajeOBlanco.pipe';
import { QuitaLetraPipe } from './pipes/quitaletra.pipe';
import { TelefonoPipeFormato } from './pipes/telefonoformato.pipe';
import { UsdPipeCustom } from './pipes/usd.pipe';

@NgModule({
  declarations: [
    RutDirective,
    CurrencyPipeCustom,
    MonthNamePipe,
    sharedComponents,
    RutPipe,
    RadioButtonComponent,
    HighlightTextPipe,
    DynamicPipe,
    DialogMessageComponent,
    PollComponent,
    SafePipe,
    PollButtonComponent,
    TimeoutMessageComponent,
    RutNameDirective,
    VerPassInputDirective,
    FechahoraPipeCustom,
    FechahoraPipeFormato,
    TelefonoPipeFormato,
    UsdPipeCustom,
    ClpPipeCustom,
    CantidadPipeCustom,
    MmbTituloPaginaComponent,
    MmbDropdownComponent,
    MmbDropdownAutocompleteComponent,
    MmbRadioButtonComponent,
    MmbInputMontoComponent,
    MmbInputTextComponent,
    MmbCheckboxComponent,
    MmbButtonComponent,
    NumerosDirective,
    NoSpacesDirective,
    VisualizadorClientesComponent,
    ModalFiltroResponsivoComponent,
    ModalFiltroInstrumentosComponent,
    MaskCurrencyDirective,
    FormatoMontoConDecimalesPipe,
    PercentageOrBlankPipe,
    MaskCurrencyDirective,
    QuitaLetraPipe,
    DropFilesDirective,
    FormControlFileDirective,
    ControlErrorPipe,
  ],
  imports: [CommonModule, PortalModule, RouterModule, MaterialModule, OverlayModule, LayoutModule, CdkTableModule, SuraCommonsUiModule, ReactiveFormsModule],
  exports: [
    RutDirective,
    CurrencyPipeCustom,
    MaterialModule,
    MonthNamePipe,
    sharedComponents,
    SuraCommonsUiModule,
    RutPipe,
    RadioButtonComponent,
    DynamicPipe,
    PollButtonComponent,
    RutNameDirective,
    VerPassInputDirective,
    FechahoraPipeCustom,
    FechahoraPipeFormato,
    TelefonoPipeFormato,
    UsdPipeCustom,
    ClpPipeCustom,
    CantidadPipeCustom,
    NumerosDirective,
    NoSpacesDirective,
    VisualizadorClientesComponent,
    ModalFiltroResponsivoComponent,
    MaskCurrencyDirective,
    FormatoMontoConDecimalesPipe,
    PercentageOrBlankPipe,
    QuitaLetraPipe,
    DropFilesDirective,
    FormControlFileDirective,
    ControlErrorPipe,
  ],
  entryComponents: [VisualizadorClientesComponent, TimeoutMessageComponent, ModalFiltroInstrumentosComponent],
  providers: [DecimalPipe],
})
export class SharedModule {}
